import React from 'react';
import { Checkbox } from '@srcDS/js/components/atoms/checkbox/Checkbox';
import CustomRange from '@srcDS/js/components/molecules/customRange/CustomRange';
import styles from '../Toolbar.module.scss';
import clsx from 'clsx';

import { Term } from '@srcDS/js/components/molecules/filter/Filter';
import { sortedFacetsTerm } from '@srcDS/js/components/molecules/filter/utils/sortedFacetsTerm';
import { SizeSelector } from '@srcDS/js/components/molecules/filter/sizeSelector/SizeSelector';

export const renderActiveFilterTerms = ({
  localFilters,
  activeFilter,
  handleFacetChange,
  onPriceRangeChange,
  showHelperText = false,
  isMobile = false,
}) => {
  const isSizeSelector = activeFilter.attributeId === 'variants.attributes.size';

  if (!['range', 'term', 'boolean'].includes(activeFilter.type)) {
    return null;
  }
  if (activeFilter.type === 'term' && (!activeFilter.terms || activeFilter.terms.length === 0)) return null;
  if (activeFilter.type === 'range' && !(activeFilter.max || activeFilter.min)) return null;

  const termsToRender: Term[] = localFilters[activeFilter.attributeId]?.terms || activeFilter.terms || [];

  return (
    <div className={clsx(styles.termList, { [styles.sizeWrapper]: isMobile && isSizeSelector })}>
      {activeFilter.type === 'term' || activeFilter.type === 'boolean' ? (
        sortedFacetsTerm(activeFilter.attributeId, termsToRender)?.map((term, termIndex) => {
          const value = String(term.value).toLowerCase();

          const isSelected = localFilters[activeFilter.attributeId]?.terms
            ? (localFilters[activeFilter.attributeId].terms.find((t) => t.value === term.value)?.selected ?? false)
            : term.selected;

          if (isMobile && isSizeSelector) {
            return (
              <SizeSelector
                key={term.key}
                label={term.label}
                selected={isSelected}
                onClick={(status) => {
                  handleFacetChange(activeFilter, status, termIndex, activeFilter.attributeId);
                }}
              />
            );
          }

          return (
            <label key={term.key} className={styles.termItem}>
              {/* @ts-ignore */}
              <Checkbox
                checkStatus={isSelected}
                onChange={(status: boolean) => {
                  handleFacetChange(activeFilter, status, termIndex, activeFilter.attributeId);
                }}
                variant="inverse"
                className={styles.checkbox}
              >
                {activeFilter.attributeId === 'variants.attributes.refinementcolour' && (
                  <div
                    className={styles.colorIndicator}
                    style={{
                      background:
                        value === 'multi'
                          ? 'conic-gradient(red, orange, yellow, green, blue, purple, red)'
                          : value === 'cream'
                            ? '#F5DFBD'
                            : value,
                    }}
                  />
                )}
                <span>{term.label}</span>
              </Checkbox>
              <p>({term.count})</p>
            </label>
          );
        })
      ) : activeFilter.type === 'range' ? (
        <>
          {showHelperText && (
            <span className={styles.helperTextTop}>Drag the sliders to set your desired price range. </span>
          )}
          <CustomRange
            key={`${activeFilter.max}-${activeFilter.min}`}
            facet={activeFilter}
            onPriceRangeChange={onPriceRangeChange}
          />
          {showHelperText && (
            <span className={styles.helperTextBottom}>
              Move the left slider to choose the minimum price and the right slider to select the maximum price.{' '}
            </span>
          )}
        </>
      ) : null}
    </div>
  );
};
